import React, { useState } from 'react';
// import { Tabs, Tab } from '@material-ui/core';
import UploadTab from './_tabs/UploadTab';
import UploadDataTab from './_tabs/UploadDataTab';

const TAB = {
  UPLOAD: 'Upload CSV',
  UPLOAD_DATA: 'Progress Call Data',
};

const ProgressCall = () => {
  const [selectedTab, setSelectedTab] = useState(TAB.UPLOAD);

  const activeClass = 'bg-blue-c1 text-white px-4 py-2 rounded-md cursor-pointer';
  const inactiveClass = 'bg-gray-100 text-gray-600 px-4 py-2 rounded-md cursor-pointer hover:bg-gray-200';

  const renderSelectedTab = () => {
    switch (selectedTab) {
      case TAB.UPLOAD:
        return <UploadTab />;
      case TAB.UPLOAD_DATA:
        return <UploadDataTab />;
      default:
        return null;
    }
  };

  return (
    <div>
      <h1 className='user-heading text-3xl font-semibold my-5'>
        Progress Call
      </h1>
      <div className='flex gap-2'>
        {Object.keys(TAB).map((tab) => (
          <div
            onClick={() => setSelectedTab(TAB[tab])}
            key={tab}
            className={selectedTab === TAB[tab] ? activeClass : inactiveClass}
          >
            {TAB[tab]}
          </div>
        ))}
      </div>
      <div className='mt-4'>
        {renderSelectedTab()}
      </div>
    </div>
  );
};

export default ProgressCall;
